import concat from "lodash/concat";
import get from "lodash/get";
import has from "lodash/has";

const API_NAME = "users";
const API_VERSION = "/v1";
const CACHE_TIME_MINS = 5;
const MAX_PAGE_SIZE = 500;

const modulestate = () => ({
  // The state must return a function to make the module reusable.
  directory: [],
  directoryCacheUpdateTime: null,
});
const getters = {
  directory: (state) => state.directory,
};
const mutations = {
  updateDirectory(state, directory) {
    state.directory = directory;
    state.directoryCacheUpdateTime = Math.round(new Date().getTime() / 1000);
  },
  appendDirectory(state, directory) {
    state.directory = concat(state.directory, directory);
  },
};

const actions = {
  async updateUserDirectory(context, payload) {
    // cache
    if (
      get(payload, "page", false) === false &&
      context.state.directoryCacheUpdateTime !== null &&
      context.state.directory.length > 0
    ) {
      if (
        get(payload, "nocache", false) === false &&
        context.state.directoryCacheUpdateTime + 60 * CACHE_TIME_MINS >=
          Math.round(new Date().getTime() / 1000)
      ) {
        return;
      }
    }

    const myInit = {};

    myInit.queryStringParameters = {
      page: get(payload, "page", "1"),
      pageSize: MAX_PAGE_SIZE,
      sort: JSON.stringify({ "profile.firstName": 1 }),
    };
    // payload contains filter/sort/pagination options.
    if (payload) {
      if (has(payload, "filter")) {
        myInit.queryStringParameters.filter = JSON.stringify(payload.filter);
      }
      if (has(payload, "sort")) {
        myInit.queryStringParameters.sort = JSON.stringify(payload.sort);
      }
    }

    const response = await this.$api.get(
      API_NAME,
      `${API_VERSION}/users/directory/rota`,
      myInit,
    );
    if (response.count === 0) {
      return;
    }
    if (!payload || myInit.queryStringParameters.page === "1") {
      context.commit("updateDirectory", response._embedded.users);
    } else {
      context.commit("appendDirectory", response._embedded.users);
    }
    // we need to paginate to get more
    const payload2 = {
      page: get(payload, "page", "1") * 1 + 1,
    };
    if (payload) {
      if (has(payload, "filter")) {
        payload2.filter = payload.filter;
      }
      if (has(payload, "sort")) {
        payload2.sort = payload.sort;
      }
    }
    await context.dispatch("updateUserDirectory", payload2);
  },
};

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state: modulestate,
};
